import { useAPIClient } from '@src/api';
import { useBaseQuery } from '@src/corelib/query';


function useQuery(url, params) {
  const apiClient = useAPIClient();
  return useBaseQuery(url, apiClient, params);
}

export default useQuery;
